import { useLocation, useRouter } from '@tanstack/react-router';
import { APIError, APIErrorType, useAuth } from '@vizit/auth';
import * as React from 'react';
import { useExpireSession } from '../../../hooks/use-expire-session';
import { useActiveWorkspaceId } from '../../../hooks/use-workspace-link';

function usePagesProvider() {
  const router = useRouter();
  const location = useLocation();

  const { userEmail, userId, organizationName, isVizitUser, isDisplayingBanner, organizationId, onDismissBanner } =
    useAuth();
  const activeWorkspaceId = useActiveWorkspaceId();
  const expireSession = useExpireSession();

  const avatarColor = React.useMemo(() => {
    return localStorage.getItem('avatar_index') ? Number.parseInt(localStorage.getItem('avatar_index') ?? '0') : 0;
  }, []);

  const handleOnAuthenticationError = React.useCallback(
    async (error: unknown | APIError) => {
      if (error instanceof APIError && error.type === APIErrorType.NotAuthenticated) {
        await expireSession(router, location.href);
      }
    },
    [expireSession, router, location.href],
  );

  return {
    avatarColor,
    isVizitUser,
    isDisplayingBanner,
    organizationId,
    organizationName,
    workspaceId: activeWorkspaceId,
    userEmail,
    userId,
    onAuthenticationError: handleOnAuthenticationError,
    onDismissBanner,
  };
}

export { usePagesProvider };
